import { Button, Container, Flex, Stack } from '@chakra-ui/react'
import { PageAlert } from 'brokertslib/src/components'
import { useGetCurrentOrganizationUnit } from 'brokertslib/src/hooks/useOrganizationUnit'
import { useNavigate } from 'react-router'

import { Loading } from '@/components/Loading'
import { Section } from '@/components/Section'
import { OrganizationDetail } from '@/containers/organization/OrganizationDetail'
import { OrganizationDetailHeading } from '@/containers/organization/OrganizationDetailHeading'
import { PageContent } from '@/containers/PageContent'
import { PageToolbar } from '@/containers/PageToolbar'
import { useAuth } from '@/context/AuthContext'
import { ArrowLeft, Edit, Refresh } from '@/icons'

export const OrganizationCurrentPage = () => {
  const navigate = useNavigate()
  const auth = useAuth()
  const { data, isLoading, isError, isSuccess, error, refetch } =
    useGetCurrentOrganizationUnit()

  return (
    <Section>
      <Container>
        <PageContent>
          {isLoading && <Loading large />}
          {isError && (
            <PageAlert
              status="error"
              title={
                error.request?.status === 403
                  ? 'Přístup odmítnut'
                  : 'Chyba při načítání organizace'
              }
            >
              <Stack gap={4}>
                <Button onClick={() => refetch()} colorScheme="secondary">
                  <Refresh /> Načíst znovu
                </Button>
                <Button onClick={() => navigate(-1)} variant="ghost">
                  <ArrowLeft /> Zpět
                </Button>
              </Stack>
            </PageAlert>
          )}
          {isSuccess && (
            <>
              <PageToolbar
                leftElements={<OrganizationDetailHeading {...data.data} />}
                rightElements={
                  <Flex sx={{ gap: 4 }}>
                    {auth?.user?.allowDisplayOrganizationStructure && (
                      <Button
                        variant="ghost"
                        onClick={() => navigate('/organization/list')}
                      >
                        <ArrowLeft color="secondary.500" />
                        Zpět do seznamu organizací
                      </Button>
                    )}
                    {auth?.user?.allowEditOrganizationStructure && (
                      <Button
                        colorScheme="primary"
                        onClick={() =>
                          navigate(`/organization/${data.data.id}/edit`)
                        }
                      >
                        <Edit />
                        Upravit organizaci
                      </Button>
                    )}
                  </Flex>
                }
              />

              <OrganizationDetail organization={data.data} />
            </>
          )}
        </PageContent>
      </Container>
    </Section>
  )
}
